import api from '@/api'
export default {
  // 获取教练帐号列表
  getCenterList (params) {
    return api({
      url: '/youth/youthList',
      method: 'GET',
      params
    })
  },
  getCenterListBySystem (params) {
    return api({
      url: '/youth/youthListSystem',
      method: 'GET',
      params
    })
  },
  getCenterListByOrg (params) {
    return api({
      url: '/youth/youthListOrgan',
      method: 'GET',
      params
    })
  },
  addCenter (data) {
    return api({
      url: '/youth/youthAdd',
      method: 'POST',
      data
    })
  },
  updateCenter (data) {
    return api({
      url: '/youth/youthEdit',
      method: 'PUT',
      data
    })
  },
  getCenterInfo (uuid) {
    return api({
      url: `/youth/youthInfo/${uuid}`,
      method: 'GET'
    })
  },
  getListByOrg (uuid) {
    return api({
      url: `/organ/authorizationOrganListOrgan/${uuid}`,
      method: 'GET'
    })
  },
  getListBySystem (params) {
    return api({
      url: '/organ/authorizationOrganListSystem',
      method: 'GET',
      params
    })
  },
  getYouthSettingData (params) {
    return api({
      url: '/youth/youthSettingData',
      method: 'GET',
      params
    })
  },
  setYouthSettingData (data) {
    return api({
      url: '/youth/youthSettingSave',
      method: 'POST',
      data
    })
  },
  getAllYouthList () {
    return api({
      url: '/youth/allYouthList',
      method: 'GET',
    })
  },
}
